// 文档
import request from '@/utils/request'

//查询全部文档分类列表
export function queryAllDocumentCategory() {
    return request.post('/documentCategory/queryAllDocumentCategory')
}
//查询文章章节列表
export function queryChapterByCategoryId(id) {
    return request.post('/chapter/queryChapterByCategoryId?id=' + id)
}